<script setup lang="ts">
import type { TeamMemberId } from '~/data/teamMembers'

const props = defineProps({
  id: {
    type: String as PropType<TeamMemberId>,
    required: true
  }
})

const { getTeamMemberById } = useStaticData()

const instructor = getTeamMemberById(props.id)

function handleClick() {
  if (!instructor) return
  navigateTo(`/teams/${instructor.id}`)
}
</script>

<template>
  <div v-if="instructor" class="course-instructor clickable" @click="handleClick">
    <img
      :src="`/images/database/teams/team-${instructor.id}.png`"
      :alt="instructor.name"
      class="course-instructor-img"
    >

    <h4>{{ instructor.name }}</h4>

    <p>{{ instructor.job }}</p>

    <img
      :src="`/images/database/teams/team-logo-${instructor.logo}.png`"
      :alt="instructor.name"
      class="course-instructor-logo"
    >
  </div>
</template>

<style scoped lang="scss">
.course-instructor {
  border: 1px solid var(--borderMedium);
  border-radius: 15px;
  padding: 25px;
  position: relative;
  display: flex;
  flex-direction: column;

  &-img {
    $size: 70px;
    height: $size;
    width: $size;
    border-radius: 50%;
  }

  h4 {
    margin-top: 20px;
    font-size: 1.05rem;
    line-height: 1.5rem;
  }

  p {
    width: 100%;
    font-size: 0.9rem;
    margin: 2px 0 25px;
    line-height: 1.3rem;
    padding-right: 10%;
    color: var(--textMedium);
    flex: 1;
  }

  &-logo {
    width: 55%;
    height: 25px;
    object-fit: contain;
    object-position: left bottom;
  }
}

@media (max-width: 600px) {
  .course-instructor {
    $size: 50px;
    $padding: 20px;

    padding: $padding;
    position: relative;
    padding-left: calc($size + $padding * 2);
    border-radius: 10px;

    &-img {
      height: $size;
      width: $size;
      position: absolute;
      top: $padding;
      left: $padding;
    }

    h4 {
      margin-top: 3px;
      font-size: 1.1rem;
      line-height: 1.6rem;
    }

    p {
      margin: 5px 0 20px;
    }

    &-logo {
      width: 80px;
      height: 20px;
    }
  }
}

@media (hover: hover) {
  .course-instructor:hover {
    border-color: var(--purple);
  }
}
</style>
